module.exports = __webpack_public_path__ + "img/icon-solar-production.792a73d0.svg";